import { NgModule } from '@angular/core';
import { API_BASE_URL } from 'src/NSwag/nswag-api-sps';
import { SpService } from './sp.service';
import {environment} from "../../../environment/environment";

@NgModule({
  providers: [
    SpService,
    {
      provide: API_BASE_URL,
      useValue: environment.API_BASE_URL,
    }
  ]
})
export class SpModule { }
